import React from "react";
import { normalizeUrl } from "../utils/utils";
import { getOrganizationSettings } from "../utils/storage";

export default function LogoOnly() {
  const organizationSettings = getOrganizationSettings();

  return (
    <div className="animate-fade-in shadow-large">
      <div className="h-[100px]">
        {organizationSettings.customized_app_settings[
          "customized-app-icon-url"
        ] ? (
          <img
            src={normalizeUrl(
              organizationSettings.customized_app_settings[
                "customized-app-icon-url"
              ]
            )}
            alt={`${organizationSettings.full_name} logo`}
            className="w-full h-full object-contain p-2"
          />
        ) : (
          <span className="text-white font-bold text-3xl">G</span>
        )}
      </div>
    </div>
  );
}
